import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HowItWorks from './components/HowItWorks';
import Comparison from './components/Comparison';
import Features from './components/Features';
import BlogPreview from './components/BlogPreview';
import Safety from './components/Safety';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <HowItWorks />
        <Comparison />
        <Features />
        <BlogPreview />
        <Safety />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}